import { Box } from "@chakra-ui/react";
import React from "react";

interface NormalTextProps {
  text: string;
  color?: string;
  fontSize?: string | number;
  fontWeight?: string | number;
  mb?: number | string;
}

export const SmallText: React.FC<NormalTextProps> = ({
  text,
  color = "#798692",
  fontSize = "12px",
  fontWeight = 400,
  mb = 1,
}) => {
  return (
    <Box fontSize={fontSize} fontWeight={fontWeight} color={color} mb={mb}>
      {text}
    </Box>
  );
};
